import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NeptuneApi } from '../genericApi/neptune.api';
import { AccountStatusApi } from './models/account-status.api.model';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { AccountSettingsApi } from './models/account-status.api.model';
import { ContentLibraryFolderApi } from './models/content-library-folder.api.model';
import { MediaApi, MediaSummaryApi, MediaNoteApi } from './models/content-library-media.api.model';

@Injectable()
export class ContentLibraryApi {

    constructor(
        private neptuneApi: NeptuneApi
    ) { }

    getAccountStatus(): Observable<AccountStatusApi> {
        return this.neptuneApi.api<AccountStatusApi>(
            '/content/accounts/status',
            undefined,
            HttpVerbsEnum.GET
        );
    }

    getAccountStatusById(accountId: number): Observable<AccountStatusApi> {
        return this.neptuneApi.api<AccountStatusApi>(
            `/content/admin/accounts/${accountId}`,
            undefined,
            HttpVerbsEnum.GET
        );
    }

    updateStorageLimit(accountId: number, payload: AccountSettingsApi): Observable<null> {
        return this.neptuneApi.api<null>(
            `/content/admin/accounts/${accountId}`,
            payload,
            HttpVerbsEnum.PUT
        );
    }

    getLibraryList(): Observable<ContentLibraryFolderApi[]> {
        return this.neptuneApi.api<ContentLibraryFolderApi[]>(
            '/content/libraries',
            undefined,
            HttpVerbsEnum.GET
        );
    }

    createLibrary(folder: ContentLibraryFolderApi): Observable<ContentLibraryFolderApi> {
        return this.neptuneApi.api<ContentLibraryFolderApi>(
            '/content/libraries',
            folder,
            HttpVerbsEnum.POST
        );
    }

    updateLibrary(folder: ContentLibraryFolderApi): Observable<number> {
        return this.neptuneApi.api<number>(
            `/content/libraries/${folder.id}`,
            folder,
            HttpVerbsEnum.PUT
        );
    }

    deleteLibrary(libraryId: number): Observable<null> {
        return this.neptuneApi.api<null>(
            `/content/libraries/${libraryId}`,
            undefined,
            HttpVerbsEnum.DELETE
        );
    }

    getMediaSummaries(contentId: string): Observable<MediaSummaryApi[]> {
        return this.neptuneApi.api<MediaSummaryApi[]>(
            `/content/${contentId}`,
            undefined,
            HttpVerbsEnum.GET
        );
    }

    updateMediaContent(contentId: string, model: MediaApi): Observable<number> {
        return this.neptuneApi.api<number>(
            `/content/${contentId}`,
            model,
            HttpVerbsEnum.PUT
        );
    }

    addNotes(contentId: string, note: MediaNoteApi): Observable<number> {
        return this.neptuneApi.api<number>(
            `/${contentId}/notes`,
            note,
            HttpVerbsEnum.POST
        );
    }


    updateNotes(contentId: string, noteId: number, note: MediaNoteApi): Observable<number> {
        return this.neptuneApi.api<number>(
            `/${contentId}/notes/${noteId}`,
            note,
            HttpVerbsEnum.PUT
        );
    }


    deleteNotes(contentId: string, noteId: number): Observable<number> {
        return this.neptuneApi.api<number>(
            `/${contentId}/notes/${noteId}`,
            undefined,
            HttpVerbsEnum.DELETE
        );
    }


    approveMedia(contentId: string): Observable<number> {
        return this.neptuneApi.api<number>(
            `/${contentId}/approve`,
            undefined,
            HttpVerbsEnum.PUT
        );
    }
}
